// src/frontend/data/books/BlockchainFundamentals/data/cap9.js

const CAP9 = {
  id: 9,
  slug: "cap9-monero-xmr",
  title: "Capítulo 9 — Monero (XMR): privacidad real, criptografía avanzada y gobernanza comunitaria",
  sections: [
    {
      heading: "¿Qué es Monero (XMR)?",
      text: [
        "Monero (XMR) es una privacy coin de código abierto creada en abril de 2014, con un alto nivel de privacidad y descentralización.",
        "El proyecto nació con el objetivo de ofrecer una opción segura, privada y anónima: una triada que muy pocas criptomonedas pueden ofrecer al mismo tiempo.",
        "Su enfoque en el anonimato le ha generado detractores, por la preocupación de que se use con fines ilegales debido a la dificultad de rastrear transacciones.",
        "Pese a ello, Monero es un proyecto fuerte y saludable, con una comunidad de desarrolladores y usuarios que sigue en aumento."
      ]
    },
    {
      heading: "Los 3 pilares del proyecto",
      list: [
        "Seguridad: proteger los fondos y sostener su esquema de privacidad y anonimato.",
        "Privacidad: la privacidad en Monero lo es todo; su protección total es clave.",
        "Descentralización: Monero no es dirigida por nadie; el desarrollo es meritocrático y comunitario."
      ]
    },
    {
      heading: "Inicios del proyecto: BitMonero → Monero",
      text: [
        "Monero comenzó su historia como BitMonero, un hard fork de Bytecoin.",
        "La comunidad tomó rápidamente las riendas del proyecto, cambió el nombre a Monero y aceleró su desarrollo.",
        "Su crecimiento inicial estuvo impulsado por su enfoque en privacidad y su minería orientada a equipos comunes (CPU)."
      ]
    },
    {
      heading: "¿Cómo funciona Monero? (visión general)",
      text: [
        "Monero es una criptomoneda con minería de bloques (Proof of Work), similar a Bitcoin en el mecanismo base.",
        "La diferencia crítica es su conjunto de tecnologías criptográficas que ocultan emisor, receptor y cantidades, reforzando la privacidad y la fungibilidad."
      ]
    },
    {
      heading: "Minería PoW: de CryptoNight a RandomX",
      text: [
        "Monero usó CryptoNight PoW como algoritmo orientado a minería con CPU, dificultando en gran medida el minado eficiente con GPU/ASIC y buscando incentivar descentralización.",
        "Posteriormente abandonó CryptoNight y adoptó RandomX, un esquema de minería que refuerza la resistencia ASIC y potencia el minado en CPU mediante una máquina virtual y alto uso de memoria."
      ]
    },
    {
      heading: "RandomX (explicación didáctica)",
      text: [
        "RandomX crea un núcleo de minería aleatorio que se ejecuta en una máquina virtual especialmente diseñada para este algoritmo.",
        "Este enfoque dificulta el diseño de ASIC, ya que dichos dispositivos no están optimizados para ejecutar máquinas virtuales ni instrucciones avanzadas.",
        "RandomX además exige un consumo considerable de memoria RAM, levantando barreras adicionales contra hardware especializado."
      ]
    },
    {
      heading: "Capacidades clave de RandomX",
      list: [
        "Operaciones de coma flotante de doble precisión.",
        "Matemática vectorial de 128 bits (instrucciones tipo SSE).",
        "Uso de modos de redondeo (IEEE 754).",
        "Lectura/escritura intensiva del espacio de trabajo (scratchpad).",
        "Aprovechamiento de ejecución fuera de orden y predicción de CPU.",
        "Uso de Argon2 para generar estructuras de memoria (cache) con alta demanda de RAM."
      ]
    },
    {
      heading: "Emisión y ‘tail emission’ (emisión de cola)",
      text: [
        "La emisión de Monero se divide en dos etapas: una curva principal que alcanzó ~18.132 millones de XMR hacia finales de mayo de 2022, y una emisión de cola posterior.",
        "En la emisión de cola se crean 0.6 XMR por bloque, con el objetivo de mantener incentivos a mineros incluso cuando la emisión principal termina.",
        "Esto implica un suministro máximo teóricamente infinito, pero con inflación porcentual que tiende a disminuir con el tiempo."
      ]
    },
    {
      heading: "Recompensa por bloque y tamaño dinámico",
      text: [
        "La recompensa por bloque desciende gradualmente y puede estar sujeta a penalizaciones si se minan bloques que exceden el tamaño promedio reciente.",
        "Monero utiliza un tamaño de bloque dinámico (no fijo), lo que le da flexibilidad para adaptarse a la demanda de transacciones."
      ]
    },
    {
      heading: "Privacidad del emisor: Ring Signatures (Círculos de firmas)",
      text: [
        "Los Círculos de Firmas mezclan la firma del emisor con un grupo de posibles firmantes, haciendo mucho más difícil rastrear el origen de los fondos.",
        "La idea es que un observador sepa que el firmante pertenece al ‘anillo’, pero no cuál de los miembros firmó realmente.",
        "El esquema también incluye enlazabilidad para evitar doble gasto sin revelar identidades, y resistencia a falsificación con probabilidad insignificante."
      ]
    },
    {
      heading: "Privacidad de cantidades: RingCT (Transacciones confidenciales)",
      text: [
        "Monero integra Ring Confidential Transactions (RingCT) para ocultar el monto transferido.",
        "Con ello se cierra el circuito de privacidad: se ocultan actores y cantidades de la transacción."
      ]
    },
    {
      heading: "Privacidad del receptor: Stealth Addresses (direcciones secretas)",
      text: [
        "Stealth Address protege al receptor obligando a crear direcciones únicas y no vinculables para cada pago.",
        "Aunque el receptor publique una sola dirección, los pagos reales se dirigen a direcciones derivadas que no se pueden asociar públicamente a la original.",
        "Solo emisor y receptor pueden saber a dónde se envió realmente el pago."
      ]
    },
    {
      heading: "Doble llave: view key y spend key",
      text: [
        "Al crear una cuenta, Monero genera dos llaves privadas: la llave de vista (view key) y la llave de gasto (spend key).",
        "La spend key permite gastar; la view key permite ver transacciones entrantes.",
        "Este modelo habilita transparencia selectiva: puedes entregar una view key a un auditor para ver actividad sin otorgar control sobre los fondos."
      ]
    },
    {
      heading: "Fungibilidad: por qué importa",
      text: [
        "La fungibilidad significa que cada unidad de moneda es intercambiable por otra con idénticas propiedades.",
        "En Monero, la privacidad reduce la ‘trazabilidad por historial’, dificultando que ciertas monedas queden marcadas por su pasado.",
        "Esto fortalece la idea de dinero digital fungible y resistente a censura basada en historial."
      ]
    },
    {
      heading: "Formato de direcciones y criptografía",
      text: [
        "Las direcciones de Monero tradicionalmente se describen como largas (por ejemplo, en fuentes divulgativas se menciona un formato de 95 caracteres iniciando con ‘4’).",
        "El esquema deriva de CryptoNote y usa criptografía EdDSA, diferente a ECDSA usada en Bitcoin.",
        "El objetivo es soportar el modelo de privacidad (stealth addressing y llaves separadas)."
      ]
    },
    {
      heading: "Bulletproofs: eficiencia y mejoras",
      text: [
        "Bulletproofs es un protocolo criptográfico (pruebas de conocimiento cero) incorporado para mejorar eficiencia.",
        "Su introducción requirió un hard fork, ya que cambió la forma de manejar transacciones y bloques.",
        "El resultado: transacciones más ligeras, mejores tiempos de verificación y comisiones más bajas."
      ]
    },
    {
      heading: "Escalabilidad: TPS, confirmaciones y costos",
      text: [
        "La escalabilidad se relaciona con TPS, tiempo de validación y comisiones.",
        "En el material base se menciona que Monero puede alcanzar cerca de ~1,000 TPS a pleno rendimiento (según condiciones).",
        "El tiempo promedio de bloque ronda los ~2 minutos, y se suele considerar un número de confirmaciones (por ejemplo, 18) para mayor seguridad, lo que puede traducirse en 10–30 minutos en escenarios típicos.",
        "En la referencia divulgativa se mencionan comisiones bajas en rangos aproximados de centavos, dependiendo del momento y la demanda."
      ]
    },
    {
      heading: "Hard forks en Monero: por qué ocurren",
      text: [
        "Monero ha realizado múltiples hard forks a lo largo de su historia.",
        "Las razones principales: mejorar privacidad/seguridad, incorporar avances criptográficos (como Bulletproofs) y mantener resistencia ASIC (cambios de PoW)."
      ]
    },
    {
      heading: "Gobernanza: un proyecto sin ‘jefes’",
      text: [
        "Monero se define como un desarrollo comunitario y meritocrático.",
        "El Core Team no se presenta como un mando central, sino como facilitadores/mantenedores; la comunidad puede impulsar iniciativas sin pedir permiso.",
        "La idea clave: Monero es un movimiento; puede continuar incluso si cambian actores del Core Team."
      ]
    },
    {
      heading: "The Forum Funding System (FFS)",
      text: [
        "El FFS es un sistema comunitario donde se proponen ideas, se discuten, se estructuran por hitos y se financian públicamente.",
        "Las propuestas aprobadas pasan por estados (financiamiento requerido, trabajo en progreso) y se espera transparencia en avances.",
        "Este mecanismo permite financiar desarrollo sin depender de una empresa central."
      ]
    },
    {
      heading: "Ventajas de Monero",
      list: [
        "Alto nivel de seguridad, privacidad y anonimato (por diseño).",
        "Transacciones no enlazables con usuarios de forma práctica en la capa pública.",
        "Privacidad del emisor (Ring Signatures), del receptor (Stealth) y de cantidades (RingCT).",
        "Blockchain con tamaño de bloque dinámico y escalable.",
        "Emisión de cola (0.6 XMR/bloque) para incentivar mineros a largo plazo.",
        "Transparencia selectiva mediante view key (auditable bajo control del usuario).",
        "Comunidad y desarrollo activos."
      ]
    },
    {
      heading: "Desventajas y críticas",
      list: [
        "Presión regulatoria y reputacional por su enfoque en anonimato y potencial uso indebido.",
        "Complejidad criptográfica puede ralentizar implementación de nuevas funciones.",
        "Posibles concentraciones de hashrate en pools o granjas (variable en el tiempo)."
      ]
    },
    {
      heading: "Resumen de especificaciones técnicas (alto nivel)",
      list: [
        "Tipo: criptomoneda PoW centrada en privacidad.",
        "PoW histórico: CryptoNight (varias versiones) → actual: RandomX (en el enfoque moderno).",
        "Tiempo de bloque: ~2 minutos (aprox.).",
        "Tamaño de bloque: dinámico, con límites ligados a promedios recientes.",
        "Emisión: curva principal (~18.132M hasta 2022) + tail emission (0.6 XMR por bloque).",
        "Privacidad del emisor: Ring Signatures.",
        "Privacidad del receptor: Stealth Addresses.",
        "Ocultamiento de cantidades: RingCT.",
        "Pruebas/eficiencia: Bulletproofs."
      ]
    },
    {
      heading: "Buenas prácticas al usar Monero",
      list: [
        "Usa software/wallets oficiales o de reputación verificada y evita enlaces sospechosos.",
        "Respalda tu semilla y llaves en medios seguros (offline cuando sea posible).",
        "Entiende que privacidad no elimina riesgos de estafa: verifica destinatarios y fuentes.",
        "Si compartes tu view key para auditoría, comprende qué revela y mantén tu spend key siempre privada."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "Monero es uno de los proyectos más completos del ecosistema cuando el objetivo es privacidad y fungibilidad.",
        "Su diseño combina minería PoW resistente a ASIC (RandomX) con criptografía avanzada (Ring Signatures, RingCT, Stealth, Bulletproofs).",
        "Su gobernanza comunitaria y mecanismos de financiamiento (FFS) refuerzan la descentralización.",
        "Entender Monero es entender el extremo privacy-first de las criptomonedas: dinero digital que prioriza privacidad por defecto."
      ]
    }
  ]
};

export default CAP9;
